export default __webpack_public_path__ + "39acab079129e9fcc8f0c89b74d82189.svg";